
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Empty } from 'ant-design-vue'
import { searchBrands } from '@/service/step-five'

@Component({
  model: { event: 'change' }
})
export default class BrandPicker extends Vue {
  @Prop({ default: '' }) value!: string
  @Prop({ default: '请填写商标注册证/受理通知书上的名称' }) placeholder!: string

  visible = false
  query = ''
  brands: string[] = []
  loading = false
  creating = false // 创建品牌开关
  name = '' // 创建的品牌名
  selected = '' // 选中的品牌名
  simpleImage = (Empty as any).PRESENTED_IMAGE_SIMPLE

  @Watch('value', { immediate: true })
  updateSelected(value: string) {
    this.selected = value
  }

  async search() {
    this.loading = true
    try {
      this.brands = await searchBrands(this.query)
    } catch {}
    this.loading = false
  }

  addBrand() {
    this.brands = [this.name]
    this.selected = this.name
    this.name = ''
    this.creating = false
  }

  onConfirm() {
    this.visible = false
    if (this.selected && this.selected !== this.value) {
      this.$emit('change', this.selected)
    }
  }
}
